import { render } from "./StackedSelect.vue?vue&type=template&id=d87209a8&scoped=true"
import script from "./StackedSelect.vue?vue&type=script&lang=js"
export * from "./StackedSelect.vue?vue&type=script&lang=js"

import "./StackedSelect.vue?vue&type=style&index=0&id=d87209a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87209a8"]])

export default __exports__